<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2><span langkey="phMenuGroup_DialogHeader"></span></h2>
    <div class="ya-dialog-content">
      <div class="categorymenu">
        <ul>
          <li *ngFor="let item of items; let i = index">
            <button a11y_Button [class.active]="i === activeLabelIndex"
              (click)="navigateToItem(item)">{{item.label}}</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>